import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { createRegistrar } from 'API/TRSRegistrar/createRegistrar';

const useCreateRegistrar = (onSuccess, onError) => {
    const queryClient = useQueryClient();
    const { currentCompany } = useSelector((state) => state.navigationLists);
    const { requiredScope: currentScope } = useSelector((state) => state.login);

    const createRegistrarMutation = async (registrarData) => {
        try {
            const response = await createRegistrar(registrarData, currentScope);
            return response.data;
        } catch (error) {
            console.error('Error creating registrar:', error);
            throw error;
        }
    };

    return useMutation({
        mutationFn: createRegistrarMutation,
        onSuccess: (data) => {
            // Invalidate and refetch the registrars list
            queryClient.invalidateQueries({
                queryKey: ['Registrars', currentCompany],
            });
            queryClient.invalidateQueries({ queryKey: ['Registrars'] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useCreateRegistrar;
